module.exports = __webpack_public_path__ + "img/icon_wfh.89272b0b.svg";